import { CxEvent } from '@spartacus/core';

export class GtmGgCheckoutPageEvent extends CxEvent {
  event?: string;
  ecommerce?: {
    checkout?: {
      actionField?: {
        step?: number;
      };
      products?: {
        name?: string;
        price?: string;
        id?: string;
        variant?: string;
        brand?: string;
        quantity?: number;
      }[];
    };
  };
}
